var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,264.1c-8.8,0-16,7.2-16,16,0,1.4.2,2.9.6,4.3,13.1,46.6,40.9,87.7,79.2,117.3,98.1,75.4,238.7,57.1,314.1-41,30.1-39.2,46.5-87.2,46.5-136.6C448.2,100.5,348.1.2,224.4,0,156.3,0,91.9,30.8,49.3,84c-2.8,3.4-7.8,4-11.2,1.2-1.8-1.4-2.9-3.5-3-5.8l-3.1-56.2c-.4-8.8-7.9-15.7-16.7-15.3C6.4,8.4-.4,15.9,0,24.7c0,.1,0,.2,0,.3l8,144c.5,8.8,8,15.6,16.9,15.1,1.2,0,2.4-.3,3.6-.6l136-40c8.5-2.5,13.3-11.4,10.8-19.9-2.5-8.5-11.4-13.3-19.9-10.8l-87.9,25.8c-4.2,1.2-8.7-1.2-9.9-5.4-.6-2.1-.3-4.4.8-6.3,12.5-21.3,28.9-39.9,48.5-55,33.5-25.9,74.7-39.9,117.1-39.8,105.9,0,192,86.1,192,192s-86.1,192-192,192c-42.4.1-83.6-13.9-117.1-39.8-32.8-25.3-56.6-60.6-67.9-100.5-1.9-6.9-8.2-11.7-15.4-11.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.0890c533c4e7e417dbd0be1b636a63ce.svg";
export { ForwardRef as ReactComponent };